import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MarketProDesignModule } from 'marketpro-design-lib';
import { MainAppModule } from '../main/main.module';
import { SampleAppComponent } from './components/sample-app.component';

@NgModule({
  imports: [CommonModule, MarketProDesignModule, FormsModule, MainAppModule],
  declarations: [SampleAppComponent],
})
export class SampleAppModule {}
